
<template>
  <div v-if="formatter.config">
    <div class="agInputGroup agInputGroupCentered">
      <div class="agInputGroup agInputGroupInline">
        <label>From:</label>
        <b-select
          class="agMediumInput"
          v-model="formatter.config.from"
          :options="toFromOptions"
          :disabled="disableUI"
          @keyup.native="previewField_keyup">
        </b-select>
      </div>
      <div class="agInputGroup agInputGroupInline">
        <label>To:</label>
        <b-select
          class="agMediumInput"
          v-model="formatter.config.to"
          :options="toFromOptions"
          :disabled="disableUI"
          @change="toField_change">
        </b-select>
      </div>
    </div>
    <div         
      v-if="showDateFormat"
      class="agInputGroup agInputGroupCentered">
      <label>Date Format:</label>
      <b-input
        v-model="formatter.config.dateFormat"
        placeholder="e.g. M/D/YY h:mm:ss a"
        :disabled="disableUI"
        @keyup.native="previewField_keyup">
      </b-input>
    </div>
    <div       
      v-if="showDateFormat"
      class="agInputGroup agInputGroupCentered">
      <label>Preview: {{preview}}</label>
    </div>
  </div>
</template>



<script>
// components

// modules
import Moment from "moment";

export default {
  name: "ag-dateFormatter",
  components: {},
  props: {
    disableUI: Boolean,
    formatter: Object
  },
  data() {
    return {
      toFromOptions: [{text: "Date", value: "date"}, {text:"Epoch", value: "epoch"}],
      showDateFormat: false,
      preview: ""
    };
  },
  computed: {},
  watch: {
  
  },

  created() {},

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

    toField_change() {
      if(this.formatter.config && this.formatter.config.to == "date")
        this.showDateFormat = true;
      else
        this.showDateFormat = false;
    },

    previewField_keyup() {
      this.setPreview();
    },

    // emitted Events

    // other

    reset() {
      if(this.formatter.config && this.formatter.config.to == "date")
        this.showDateFormat = true;
      else
        this.showDateFormat = false;
      this.setPreview();
    },

    prepareForSave() {},

    setPreview() {
      this.preview = "";

      if (this.formatter.config.dateFormat) {
        var now = new Date();
        this.preview = Moment(now).format(this.formatter.config.dateFormat);
      }
      return this.preview;
    }
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/DateFormatter.vue